var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7003 12.0601C10.3974 12.0534 10.1537 11.8001 10.1537 11.4934C10.1471 11.1867 10.3908 10.9341 10.6937 10.9274H10.7003C11.0099 10.9274 11.2602 11.1807 11.2602 11.4934C11.2602 11.8067 11.0099 12.0601 10.7003 12.0601ZM8.01317 9.60672C7.71021 9.62072 7.45993 9.38005 7.44676 9.07405C7.44676 8.76739 7.68386 8.51405 7.98683 8.50005C8.28321 8.50005 8.52689 8.73405 8.53348 9.03339C8.54665 9.34072 8.30955 9.59405 8.01317 9.60672ZM8.01317 12.0267C7.71021 12.0407 7.45993 11.8001 7.44676 11.4934C7.44676 11.1867 7.68386 10.9341 7.98683 10.9201C8.28321 10.9201 8.52689 11.1541 8.53348 11.4541C8.54665 11.7607 8.30955 12.0141 8.01317 12.0267ZM5.30626 9.60672C5.00329 9.62072 4.75302 9.38005 4.73985 9.07405C4.73985 8.76739 4.97695 8.51405 5.27991 8.50005C5.57629 8.50005 5.81998 8.73405 5.82656 9.03339C5.83974 9.34072 5.60263 9.59405 5.30626 9.60672ZM5.29967 12.0267C4.99671 12.0407 4.74643 11.8001 4.73326 11.4934C4.73326 11.1867 4.97036 10.9341 5.27333 10.9201C5.5697 10.9201 5.81339 11.1541 5.81998 11.4541C5.83315 11.7607 5.59605 12.0141 5.29967 12.0267ZM10.1603 9.06739C10.1603 8.76072 10.3974 8.51405 10.7003 8.50739C10.9967 8.50739 11.2338 8.74672 11.247 9.04072C11.2536 9.34739 11.0165 9.60072 10.7201 9.60672C10.4171 9.61339 10.1669 9.38005 10.1603 9.07405V9.06739ZM2 6.17139V11.2467C2 13.3534 3.33041 14.6667 5.41822 14.6667H10.5752C12.6828 14.6667 14 13.3801 14 11.2874V6.17139H2Z",
    fill: "url(#paint0_linear_0_11353)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M2.00195 6.17133C2.01052 5.77999 2.04345 5.00333 2.10536 4.75333C2.42149 3.34733 3.49504 2.45399 5.02961 2.32666H10.9703C12.4917 2.46066 13.5785 3.35999 13.8946 4.75333C13.9558 4.99666 13.9888 5.77933 13.9973 6.17133H2.00195Z",
    fill: "url(#paint1_linear_0_11353)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.53643 4.3935C5.82622 4.3935 6.04357 4.17416 6.04357 3.88016V1.8475C6.04357 1.5535 5.82622 1.3335 5.53643 1.3335C5.24664 1.3335 5.0293 1.5535 5.0293 1.8475V3.88016C5.0293 4.17416 5.24664 4.3935 5.53643 4.3935Z",
    fill: "url(#paint2_linear_0_11353)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4632 4.3935C10.7464 4.3935 10.9703 4.17416 10.9703 3.88016V1.8475C10.9703 1.5535 10.7464 1.3335 10.4632 1.3335C10.1734 1.3335 9.95605 1.5535 9.95605 1.8475V3.88016C9.95605 4.17416 10.1734 4.3935 10.4632 4.3935Z",
    fill: "url(#paint3_linear_0_11353)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_11353",
    x1: 8,
    y1: 6.17139,
    x2: 8,
    y2: 14.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A674A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C3D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_11353",
    x1: 7.99965,
    y1: 2.32666,
    x2: 7.99965,
    y2: 6.17133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A674A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C3D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_11353",
    x1: 5.53643,
    y1: 1.3335,
    x2: 5.53643,
    y2: 4.3935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A674A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C3D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_11353",
    x1: 10.4632,
    y1: 1.3335,
    x2: 10.4632,
    y2: 4.3935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A674A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C3D1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.17bfe21b5b48c9991defd7d66b30b4ad.svg";
export { ForwardRef as ReactComponent };